import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export function AllergyNotice({ compact = false, minimal = false }) {
  if (minimal) {
    return (
      <aside
        className="mb-6 flex flex-nowrap items-center gap-1.5 whitespace-nowrap text-xs text-neutral-600 sm:text-sm"
        data-testid="food-allergy-notice"
      >
        <span className="font-medium text-neutral-800">Food allergy & raw seafood notice</span>
        <Link
          to="/food-allergens"
          className="font-semibold text-[hsl(var(--primary))] underline underline-offset-2"
          data-testid="food-allergy-notice-link"
        >
          Read full notice
        </Link>
      </aside>
    );
  }

  return (
    <aside
      className={`rounded-xl border border-amber-200 bg-amber-50 text-amber-950 ${
        compact ? "px-4 py-3" : "mb-8 px-5 py-4"
      }`}
      data-testid="food-allergy-notice"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-700" />
        <div className="text-sm leading-relaxed">
          <p className="font-semibold">Food allergy & raw seafood notice</p>
          <p className="mt-1 text-amber-900">
            Some items contain raw or undercooked seafood and common allergens. Shared equipment may
            create cross-contact. Please tell our team about food allergies before ordering.
            {" "}
            <Link to="/food-allergens" className="font-semibold underline underline-offset-2">
              Read the full notice.
            </Link>
          </p>
        </div>
      </div>
    </aside>
  );
}